import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommissionHoldRelease } from 'src/app/model/commission-hold-release.model';
import { AuthService } from 'src/app/services/auth.service';
import { CatComponentService } from 'src/app/services/cat-component.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { CommissionHoldReleaseService } from 'src/app/services/commission-hold-release.service';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-modal-hold-release-bitacore',
  templateUrl: './modal-hold-release-bitacore.component.html',
  styleUrls: ['./modal-hold-release-bitacore.component.css']
})
export class ModalCommissionHoldReleaseBitComponent implements OnInit {

  @Input() idCredit: number;
  @Input() idAreaRole: string;
  @Input() retencion: any;
  public viewStatus: number = 0;
  public listCommissionToHold: any[] = [];
  public objCommissionToHold: any = {};

  statusOptions = [
    { value: 'PPR', label: 'Pendiente por Retener' },
    { value: 'RT', label: 'Retenido' },
    { value: 'PPL', label: 'Pendiente por Liberar' },
    { value: 'LB', label: 'Liberado' }
  ];

  public columnsGridBitacora: string[] = ["Tipo", "Figura Retención", "Motivo Descuento", "% a Descontar",
    "Monto Retenido", "Monto Pendiente", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area"];

  public columnsGridBitacoraFin: string[] = ["Tipo", "Figura Retención", "Motivo Descuento", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area"];

  montoComisionField: boolean = false;

  dtOptions = {
    order: [],
    responsive: true,

    select: "single",
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"B><"col"<"text-center">><"col"f>><"row"<"col"t>><"row"<"col"p>>',
    buttons: ["csv", "excel"],
    autoWidth: true,
    columnDefs: [
      { responsivePriority: 1, targets: 0 },
      { responsivePriority: 5, targets: -1 },
    ],
    pageLength: 10,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
    },
  };

  constructor(private toastr: ToastrService,
    private modalService: NgbModal,
    private catComponentService: CatComponentService,
    private auth: AuthService,
    private otherCatalogsService: OtherCatalogsService,
    private commissionHoldReleaseService: CommissionHoldReleaseService,) { }


  ngOnInit() {
    let modalContent: any = $(".modal-content");
    modalContent.draggable({ handle: ".card-header" });
    console.log("Apertura del modal", this.retencion);
    this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
      elementGrant.data.filter(el => el.component === "app-view-hold-release-commission" && this.auth.getUserRoles().includes(el.role))
        .map(el => {
          this.montoComisionField = el.active
          console.log("Botn service: ", this.montoComisionField);
        });
    });

    const requestObject = {
      idCredito: this.idCredit != null ? Number(this.idCredit) : null,
      asesor: this.idAreaRole != null ? this.idAreaRole : "",
      tipoReporte: 'bitacora'
    };
    console.log("Request Object: ", requestObject);
    this.commissionHoldReleaseService.getCommissionByFilters(requestObject)
      .pipe(
        tap((resp: any) => {
          if (resp.data != null && Object.keys(resp.data).length > 0) {
            console.log("Respuesta de la bitacora: ", resp.data);
            this.objCommissionToHold = this.retencion;
            this.listCommissionToHold =  resp.data;
            this.viewStatus = 1;
          }
        }),
        catchError(error => {
          console.log("Error al obtener la información de la bitacora: ", error);
          return of(this.toastr.error('Ocurrió un error al obtener la información.'));
        })
      ).subscribe();

  }

  close = () => {
    this.modalService.dismissAll('failure');
  }

  validateNumber(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which || event.keyCode);
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault(); // Block non-numeric characters
      this.toastr.warning("El campo solo acepta datos numericos!")
    }
  }

  validatePaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pasteData)) {
      event.preventDefault(); // Block paste if not numeric
      this.toastr.warning("El campo solo acepta datos numericos!")
    }
  }

  getStatusDescription(type: string, statusCode: string): string {
    if (type === 'status') {
      return this.statusOptions.find(option => option.value === statusCode).label || statusCode;
    } else if (type === 'type') {
      return statusCode == "1" ? "Retención" : "Liberación";
    }
  }
}
